import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { SIREN_CONFIG } from 'config.js';
import { Functionalities, Notifications, Password } from './components';




const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Settings = (props) => {
  const {className, history, ...rest} = props;

  const classes = useStyles();

  const [settingsInfo, setSettingsInfo] = React.useState({
    facilityType:'facility',
    keepOnFall:'0',
    firebaseRoot: '',
  });


  return (
    <div className={classes.root}>
      <Grid container spacing={2}>

        <Grid item md={6} xs={12}>
          <Functionalities />
        </Grid>

        {/* <Grid item md={7} xs={12}>
          <Notifications />
        </Grid>

        <Grid item md={5} xs={12}>
          <Password />
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Settings;
